/**
 * Utility functions for managing booking progress in localStorage
 */
import logger from "./logger";

const BOOKING_PROGRESS_KEY = "mikey_booking_progress";

/**
 * Load booking progress from localStorage
 * Returns the progress object if valid, or null
 * @param {string} serviceSlug - Optional: only return progress for this service
 */
export function loadProgressFromStorage(serviceSlug = null) {
  try {
    const saved = localStorage.getItem(BOOKING_PROGRESS_KEY);
    if (!saved) return null;

    const progress = JSON.parse(saved);

    // If serviceSlug is provided, check if it matches
    if (serviceSlug && progress.serviceSlug !== serviceSlug) {
      return null;
    }

    // Check if progress is less than 24 hours old
    const savedAt = new Date(progress.savedAt);
    const now = new Date();
    const hoursDiff = (now - savedAt) / (1000 * 60 * 60);

    if (hoursDiff > 24) {
      localStorage.removeItem(BOOKING_PROGRESS_KEY);
      return null;
    }

    return progress;
  } catch (error) {
    logger.error("Failed to load booking progress:", error);
    return null;
  }
}

/**
 * Save booking progress to localStorage
 * @param {Object} progress - The progress object to save
 */
export function saveProgressToStorage(progress) {
  try {
    const progressWithTimestamp = {
      ...progress,
      savedAt: new Date().toISOString(),
    };
    localStorage.setItem(
      BOOKING_PROGRESS_KEY,
      JSON.stringify(progressWithTimestamp),
    );
  } catch (error) {
    logger.error("Failed to save booking progress:", error);
  }
}

/**
 * Clear booking progress from localStorage
 */
export function clearProgressFromStorage() {
  localStorage.removeItem(BOOKING_PROGRESS_KEY);
}
